import SEO from "../common/SEO";
import Layout from "../common/Layout";
import { seo } from "../data/seo";

const PrivacyPolicy = () => {
    return (
        <>
            <SEO
                title={seo.privacy.title}
                description={seo.privacy.description}
                ogTitle={seo.privacy.ogTitle}
                ogDescription={seo.privacy.ogDescription}
            />
            <Layout>
                <div className="main-content">
                    {/* Start Contact Area  */}
                    <div className="rwt-contact-area rn-section-gap">
                        <div className="container">
                            <h1>Privacy Policy for regina-nigma.com</h1>

                            <p>Last updated: 6th of October 2023.</p>

                            <p><strong>1. Introduction</strong></p>
                            <p>Welcome to regina-nigma.com ("me," "mine"). At regina-nigma.com, I respect your privacy
                                and am committed to protecting your personal information. This Privacy Policy is
                                designed to help you understand how I collect, use, disclose, and safeguard your
                                personal information when you visit or use my website.</p>

                            <p><strong>2. Information I Collect</strong></p>
                            <p>2.1. <strong>Personal Information</strong>: When you use my website, I may collect
                                personal information that you provide to me, such as your name, email address, and any
                                other information you choose to share with me through scheduling a call or email
                                communication.</p>
                            <p>2.2. <strong>Log Data</strong>: I may collect information that your browser sends
                                whenever you visit my website. This may include your IP address, browser type, the
                                pages you visit, and the time and date of your visit.</p>

                            <p><strong>3. How I Use Your Information</strong></p>
                            <p>I may use your personal information for the following purposes:</p>
                            <p>3.1. To respond to your inquiries or requests submitted through scheduling a call or email
                                communication.</p>
                            <p>3.2. To improve my website and services.</p>

                            <p><strong>4. Cookies and Tracking Technologies</strong></p>
                            <p>My website may use cookies and similar tracking technologies to enhance your user experience.
                                You can adjust your browser settings to refuse cookies or alert you when cookies are
                                being sent.</p>

                            <p><strong>5. Disclosure of Your Information</strong></p>
                            <p>I do not sell, trade, or otherwise transfer your personal information to third parties.
                                I may disclose your information only in the following circumstances:</p>
                            <p>5.1. When required by law or legal process.</p>
                            <p>5.2. To protect my rights, privacy, safety, or property.</p>

                            <p><strong>6. Third-Party Links</strong></p>
                            <p>My website may contain links to third-party websites. I am not responsible for the
                                content or privacy practices of these websites. I encourage you to review the privacy
                                policies of these websites before providing any personal information.</p>

                            <p><strong>7. Security</strong></p>
                            <p>I take reasonable measures to protect your personal information from unauthorized
                                access, use, or disclosure. However, no method of data transmission over the
                                internet or electronic storage is completely secure, so I cannot guarantee
                                absolute security.</p>

                            <p><strong>8. Children's Privacy</strong></p>
                            <p>My website is not directed toward individuals under the age of 13. I do not knowingly
                                collect personal information from children under 13. If you believe that a child
                                has provided me with their personal information, please contact me, and I will
                                delete that information.</p>

                            <p><strong>9. Changes to this Privacy Policy</strong></p>
                            <p>I may update this Privacy Policy from time to time to reflect changes in my practices or
                                for other operational, legal, or regulatory reasons. The most current version of the
                                Privacy Policy will be posted on my website with the updated date.</p>

                            <p><strong>10. Contact Me</strong></p>
                            <p>If you have any questions or concerns regarding this Privacy Policy or the handling
                                of your personal information, please contact me at&nbsp;
                                <a href="mailto:nigmatullinaregina@gmail.com">nigmatullinaregina@gmail.com</a>.</p>
                        </div>
                    </div>
                    {/* End Contact Area  */}
                </div>
            </Layout>
        </>
)
}
export default PrivacyPolicy;